import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Col, Row, Button, Badge } from "reactstrap";
import axios from "axios";
import Header from "../../layout/Header/Header";

function BotonesCompras() {
  const { user } = useContext(AuthContext);
  const [pendientesEntradas, setPendientesEntradas] = useState(0);

  // U24: contar OC pendientes de recibir / entrar
  useEffect(() => {
    const URL = process.env.REACT_APP_URL_ORDENES_COMPRA;
    if (!URL) return;
    axios
      .get(URL, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((res) => {
        const ocs = (res.data || []).filter(
          (oc) => oc.is_active !== "No" && (oc.recibido === "No" || (oc.status || "Abierto") === "Abierto")
        );
        setPendientesEntradas(ocs.length);
      })
      .catch(() => setPendientesEntradas(0));
  }, []);

  const Btn = ({ permitido, href, icon, label, badge }) => (
    <Col md={4} align="center">
      {permitido ? (
        <Button href={href} className="botonesMenu" color="success" style={{ position: "relative" }}>
          {badge != null && badge > 0 && (
            <Badge color="danger" style={{ position: "absolute", top: 8, right: 8, fontSize: 14 }}>
              {badge}
            </Badge>
          )}
          <i className={`fas ${icon} fa-7x`}></i>
          <br />
          <br />
          {label}
        </Button>
      ) : (
        <Button disabled className="botonesMenu" color="success">
          <i className={`fas ${icon} fa-7x`}></i>
          <br />
          <br />
          {label}
        </Button>
      )}
    </Col>
  );

  const Seccion = ({ titulo }) => (
    <>
      <br />
      <h4 style={{ borderBottom: "2px solid #f28029", paddingBottom: 6, marginBottom: 16, color: "#333" }}>
        {titulo}
      </h4>
    </>
  );

  return (
    <>
      <Header />
      {user.menu_compras ? (
        <div className="container">
          <br />

          {/* ===== COMPRAS ===== */}
          <Seccion titulo="Compras" />
          <Row>
            <Btn permitido={user.menu_oc} href="/ListadoOrdenesCompra" icon="fa-shopping-basket" label="Ordenes de Compra" />
            <Btn permitido={user.menu_compras} href="/ListadoCompras" icon="fa-cart-plus" label="Entradas" badge={pendientesEntradas} />
            <Btn permitido={user.menu_compras} href="/ComprasDirectasCreate" icon="fa-cash-register" label="Compras Directas" />
          </Row>

          {/* ===== EMBARQUES ===== */}
          <Seccion titulo="Embarques" />
          <Row>
            <Btn permitido={user.pendiente_embarcar} href="/ListadoPendEmbarcar" icon="fa-plane-departure" label="Pendiente Embarcar" />
            <Btn permitido={user.embarques} href="/ListadoEmbarques" icon="fa-ship" label="Embarques" />
            <Btn permitido={user.pendiente_recibir} href="/ListadoPendRecibir" icon="fa-plane-arrival" label="Pendiente Recibir" />
          </Row>
          <br />
          <Row>
            <Btn permitido={user.menu_compras} href="/EmbarquesDirectosCreate" icon="fa-anchor" label="Embarques Directos" />
            <Btn permitido={user.menu_compras} href="/ConceptosGastosEmbarques" icon="fa-tags" label="Conceptos Gastos" />
          </Row>

          {/* ===== CATÁLOGOS ===== */}
          <Seccion titulo="Catálogos" />
          <Row>
            <Btn permitido={user.menu_proveedores} href="/Proveedores" icon="fa-dolly" label="Proveedores" />
            <Btn permitido={user.menu_proveedores} href="/ListadoBrokers" icon="fa-user-tie" label="Brokers" />
          </Row>

          {/* ===== DEVOLUCIONES ===== */}
          <Seccion titulo="Devoluciones" />
          <Row>
            <Btn permitido={user.menu_compras} href="/ListadoDevolucionesProveedores" icon="fa-undo-alt" label="Devoluciones Proveedores" />
          </Row>

          {/* ===== REPORTES ===== */}
          <Seccion titulo="Reportes" />
          <Row>
            <Btn permitido={user.menuCalidad} href="/ReporteCompras" icon="fa-shopping-cart" label="Reporte Compras" />
          </Row>

          <br />
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default BotonesCompras;
